import { Component, EventEmitter, HostListener, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ImageCroppedEvent, ImageCropperModule } from 'ngx-image-cropper';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CommonValues } from 'src/app/services/commonValues';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { BussinessPostComponent } from '../../bussiness-post/bussiness-post.component';
import { GlobalCommunity } from '../../../services/globalCommunity.service';
import { GigsumoService } from 'src/app/services/gigsumoService';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-community-banner',
  standalone: true,
  imports: [CommonModule, ImageCropperModule,
    NG_ICON_DIRECTIVES,
  ],
  host: { 'class': 'business-banner-top post-box-shadow border-radius-bottom-left-right-6' },
  templateUrl: './community-banner.component.html',
  styleUrls: ['./community-banner.component.scss']
})
export class CommunityBannerComponent implements OnInit {
  @ViewChild('myFileInput') myFileInput;
  @Output()  updateFunction = new EventEmitter();
  communitydata;
  adminData
  adminflag: Boolean;
  follwing: Boolean = true;
  bannerflag: Boolean = false;
  communityId
  businessdata
  viewasmembers: Boolean = false; 
  viewasAdmin: Boolean = false; 
  clickEventsubscription: Subscription;
  bannerimg: any = "";
  businesslogs: any = "";
  banner
  userData = []
  values: any = { adminviewnavigation: false }
  userId = localStorage.getItem('userId')
  fileUploadName
  imageChangedEvent: any = '';
  croppedImage: any = '';
  modalRef: any;
  fileToUpload: File;
  photoId
  img: { src: string; };
  isAdmin: any
  isSuperAdmin: any
  @Output() onAddcommunity = new EventEmitter();
  formData: FormData;
  communityTypes
  communityName
  communitytag
  CisAdmin = false
  CisSuperAdmin = false
  cisJoined = false
  private lastKnownJoinedCommunityId: string | null = null;
  private lastKnownJoined: boolean = false;
  private membershipPollInterval: any;
  private lastMembershipCheckAt = 0;
  // Any click anywhere on the page (not just menu clicks) re-checks
  // membership, but throttled so a burst of clicks doesn't turn into a
  // burst of API calls - one check per window is enough to catch a revoke.
  private readonly MEMBERSHIP_CHECK_THROTTLE_MS = 5000;
  joinStatus: any
  Status: boolean = true
  isJoined: any
  eventEmitter2: Subscription;
  menu
  getcount
  PHOTOURL = AppSettings.photoUrl;
  constructor(
    private API: ApiService,
    // Removed: private posts: BussinessPostComponent - component should not be injected as service
    private modalService: BsModalService,
    private route: ActivatedRoute,
    private commonvalues: CommonValues,
    private util: UtilService,
    public globalCommunity : GlobalCommunity,
    private router: Router,
    private gigsumoService: GigsumoService,
  ) {
    this.clickEventsubscription = this.commonvalues.getcommunitydata().subscribe((res) => {
      this.values = res; 
      this.viewasAdmin = res.viewasAdmin;
      this.viewasmembers = res.viewasmembers;      
    });

    this.eventEmitter2 = this.commonvalues.getCommuityBoolean().subscribe(res=>{
      if(res.boolean == true){
        // this.ngOnInit()
        this.companydetailsapicall()
      }
  })


  }

  ngOnDestroy() {
    //this.router.routeReuseStrategy.shouldReuseRoute = () => true;
    if (this.membershipPollInterval) {
      clearInterval(this.membershipPollInterval);
    }
  }

  ngAfterViewInit( ): void {
    setInterval(() => {
      const stored = localStorage.getItem('communitycount');
      if (stored == null || stored === 'undefined') {
        return;
      }
      // Only react to an actual change, and EMIT when it happens.
      //
      // Assigning this.getcount alone is not enough: the "N Members" pill is rendered by
      // community.component as `businesBannerData?.getcount`, and that object only arrives
      // through sendDataFunction()'s updateFunction emit. Without the emit the banner kept
      // showing the old number even when localStorage and community/home both had the new
      // one - member revoked, API said 706, localStorage said 706, pill still said 707.
      if (stored !== String(this.getcount)) {
        this.getcount = stored;
        this.sendDataFunction();
      }
    }, 500);

  }


  ngOnInit() {
    // window.scrollTo(0, 0);
    if (this.isSuperAdmin) {
      this.isAdmin = this.isSuperAdmin
    }

    this.route.queryParams.subscribe((res) => {
      this.communityId = res.communityId;
      if(res.menu=="memberspage"){
        this.values.menu = "memberspage"
      }else if(res.menu=="request"){
        this.values.menu = "request"
      }else  if(res.menu=="communityabout"){
        this.values.menu = "communityabout"
      }
      this.values.communityId = res.communityId;
      this.values.userId = res.communityId;

      if(res){
        this.companydetailsapicall()
      }
    });
    ////// console.log("community banner ngOnInit");
    // this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    // There's no backend push for "a super admin just removed you" - only
    // the next click/refresh notices. Poll quietly in the background so a
    // mid-session removal gets caught (and the user redirected out) even if
    // the user never clicks anything at all.
    this.membershipPollInterval = setInterval(() => {
      this.checkMembershipIfDue();
    }, 30000);
  }

  // Fires on every click anywhere on the page (menu clicks, post likes,
  // opening a modal, etc.) - any interaction is a chance to notice a
  // mid-session revoke, on top of the 30s background poll.
  @HostListener('document:click')
  onAnyPageInteraction() {
    this.checkMembershipIfDue();
  }

  private checkMembershipIfDue() {
    if (!this.communityId) {
      return;
    }
    const now = Date.now();
    if (now - this.lastMembershipCheckAt < this.MEMBERSHIP_CHECK_THROTTLE_MS) {
      return;
    }
    this.lastMembershipCheckAt = now;
    this.companyHome(this.communityId, this.communityTypes, true, true);
  }


  addJoin() {
    let datas: any = {};
    datas.communityId = this.communityId
    datas.userId = localStorage.getItem('userId');
    this.util.startLoader()
    this.API.create("community/join", datas).subscribe(res => {
      this.util.stopLoader()
      if (res.code == "00000") {
        let alertTitle = 'Join request sent successfully';
        if (this.communityTypes == true) {
          alertTitle = 'Join request sent successfully';
        }
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: alertTitle,
          showConfirmButton: false,
          timer: 3000
        }).then((result) => {
          this.cisJoined = true;
          this.companyHome(this.communityId, this.communityTypes);
        })


      }
    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while processing your request. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });
  }

  removeJoin() {
    let datas: any = {};
    datas.communityId = this.communityId
    datas.userId = localStorage.getItem('userId');
    this.util.startLoader()
    this.API.create("community/join/remove", datas).subscribe(res => {
      this.util.stopLoader()
      if (res.code == "00000") {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'You have left the community',
          showConfirmButton: false,
          timer: 2000
        }).then((result) => {
          this.cisJoined = false;
          this.values.adminviewnavigation = false
          this.companyHome(this.communityId, this.communityTypes);
        });
      }
    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while processing your request. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });
  }


  cancelrequest() {
    let datas: any = {};
    datas.communityId = this.communityId
    datas.userId = localStorage.getItem('userId');
    this.util.startLoader()
    this.API.create("community/join/cancel", datas).subscribe(res => {
      this.util.stopLoader()
      if (res.code == "00000") {
        this.cisJoined = false;
        this.companyHome(this.communityId, this.communityTypes);

      }

    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while processing your request. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });
  }



  acceptInvite() {
    let datas: any = {};
    datas.entityId = this.communityId
    datas.userId = localStorage.getItem('userId');
    this.util.startLoader()
    this.API.create("community/accept/invite", datas).subscribe(res => {
      this.util.stopLoader()
      if (res.code == "00000") {
        this.cisJoined = false;
        this.companyHome(this.communityId, this.communityTypes);
      }
    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while accepting invitation. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });
  }





  cancelinvite() {
    let datas: any = {};
    datas.entityId = this.communityId
    datas.userId = localStorage.getItem('userId');
    this.util.startLoader()
    this.API.create("community/reject/invite", datas).subscribe(res => {
      this.util.stopLoader()
      if (res.code == "00000") {
        this.cisJoined = false;
        this.companyHome(this.communityId, this.communityTypes);
      }
    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while processing your request. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });
  }





  companydetailsapicall() {
    this.viewasmembers = false

    var data = this.communityId
    if (this.communityId) {
      data = this.values.communityId;
    }
    this.util.startLoader();
    this.API.query('community/details/' + data).subscribe(res => {
      this.util.stopLoader();
      this.communitydata = res.data.communityDetails;
      this.globalCommunity.setCommunityBannerData(this.communitydata);

      // memberCnt is NOT written here any more. It is a stored counter that ~10 paths adjust
      // by +/-1, so it drifts - and because this method re-runs on several events, it kept
      // overwriting the live count with the stale one (banner stuck on 709 after a revoke took
      // the real total to 708). companyHome() below sets the count from noOfMembers, which is
      // derived from the actual membership rows.
      // localStorage.setItem("communitycount", res.data.communityDetails.memberCnt);
      // this.getcount = res.data.communityDetails.memberCnt;

      this.communityTypes = res.data.communityDetails.communityType;
      this.communityName = res.data.communityDetails.communityName;
      this.communitytag = res.data.communityDetails.tagLine;
      this.values.userId = this.userId
      this.businesslogs =    AppSettings.photoUrl + this.globalCommunity.communityBannerDetails.logo
      this.bannerimg =   AppSettings.photoUrl + this.globalCommunity.communityBannerDetails.banner
      this.companyHome(res.data.communityDetails.communityId, res.data.communityDetails.communityType, true)

      this.sendDataFunction();

    }, err => {
      this.util.stopLoader();

    });

  }

  sendingData : any;
  sendDataFunction(val ?: any) {
    this.sendingData = {
      communityName : this.communityName,
      communityTypes : this.communityTypes,
      communitytag : this.communitytag,
      adminview : this.adminview,
      viewasmembers : this.viewasmembers,
      viewasmember : this.viewasmember,
      getcount : this.getcount,
      addJoin : this.addJoin,
      members: this.members,
      cisJoined : this.cisJoined,
      CisAdmin : this.CisAdmin,
      CisSuperAdmin : this.CisSuperAdmin,
      Status : this.Status,
      cancelrequest : this.cancelrequest,
      acceptInvite : this.acceptInvite,
    }

    this.updateFunction.emit({
      ...this.sendingData,
      ...this,
      ...val
    });

  }

  private closeAllModals() {
    // Modals stack with ids 1..n; hide each (extra ids are harmless no-ops).
    const count = this.modalService.getModalsCount();
    for (let i = count; i >= 1; i--) {
      this.modalService.hide(i);
    }
  }

  companyHome(id, communityType, checkRevokedAccess: boolean = false, silent: boolean = false) {
    // Any community/home call counts as a membership check, so the click watchdog does not
    // fire a SECOND one straight after. Navigating between Home / About us / Members / Page
    // Admin already calls this through companydetailsapicall(), and the click that caused the
    // navigation used to trigger checkMembershipIfDue() as well - two identical requests per
    // menu click. Stamping the throttle here collapses them to one.
    this.lastMembershipCheckAt = Date.now();

    //////// console.log("companyHome - " + id + " - " + communityType);
    // A super admin can remove this user from the community while they're
    // still sitting on this page. That doesn't error - the next refresh just
    // comes back with isJoined:false - so compare against the last CONFIRMED
    // state for this same community (not the optimistic cisJoined flag the
    // join/leave actions below set before this same call) to tell "was a
    // member, just got kicked" apart from "never was a member of this one".
    // `silent` is for the background membership poll - it skips the loader
    // spinner so a passive check every 30s doesn't flash it across the page.
    const wasConfirmedMember = checkRevokedAccess &&
      this.lastKnownJoinedCommunityId === String(id) &&
      this.lastKnownJoined === true;

    let data: any = {}
    data.communityId = id;
    data.userId = localStorage.getItem('userId')
    if (!silent) {
      this.util.startLoader()
    }
    this.API.create('community/home', data).subscribe(res => {
      if (!silent) {
        this.util.stopLoader()
      }

      if (wasConfirmedMember && !res.data.isJoined) {
        this.lastKnownJoinedCommunityId = String(id);
        this.lastKnownJoined = false;
        // Modals (e.g. Share) are attached to <body>, outside the router
        // outlet, so they survive the redirect unless closed explicitly.
        this.closeAllModals();
        Swal.fire({
          icon: "info",
          title: "You have been removed from this Community",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          this.router.navigate(['landingPage']);
        });
        return;
      }

      this.lastKnownJoinedCommunityId = String(id);
      this.lastKnownJoined = !!res.data.isJoined;

      // The banner's "N Members" line. noOfMembers is counted live from the membership rows
      // (CommunityService.communityHome -> memberList.size()), unlike community/details'
      // memberCnt, which is a stored counter and drifts. Set on the SILENT poll too - that is
      // the click-triggered membership check, and it is the thing that keeps the number
      // honest between page loads.
      if (res.data.noOfMembers != null) {
        const incoming = String(res.data.noOfMembers);
        localStorage.setItem('communitycount', incoming);

        // EMIT here, do not rely on the 500ms poll. That poll only fires when localStorage
        // differs from this.getcount - and setting both together made them equal, so it never
        // emitted and businesBannerData (what the pill actually renders) kept the old number.
        if (incoming !== String(this.getcount)) {
          this.getcount = res.data.noOfMembers;
          this.sendDataFunction();
        }
      }

      // Silent poll and nothing changed: stop here. The full sync below
      // resets values.menu back to "communityhome", which would otherwise
      // silently yank a user off the Members/About tab they're on every
      // 30 seconds even though nothing about their access changed.
      if (silent) {
        return;
      }

      this.adminData = res.data.communityhome;
      if (res.data.isSuperAdmin) {
        this.adminData.isAdmin = true
      }
      this.adminData.isSuperAdmin = res.data.isSuperAdmin
      this.CisAdmin = res.data.isAdmin
      this.CisSuperAdmin = res.data.isSuperAdmin
      this.cisJoined = res.data.isJoined

      this.joinStatus = res.data.joinStatus;

      if (this.CisAdmin == true) {
        this.adminview(this,true)
      } else if (this.CisSuperAdmin == true) {
        this.adminview(this,true)
      } else if (this.cisJoined) {
        this.values.membersflage = false
        this.values.adminviewnavigation = true
        this.values.menu = "communityhome";
      } else if (!this.cisJoined) {
        this.values.menu = "communityhome";
      }

      this.values.communityId = this.communityId;
      this.values.communityType = communityType;
      this.values.communityName = res.data.communityName;
      this.values.isAdmin = res.data.isAdmin;
      this.values.isSuperAdmin = res.data.isSuperAdmin;

      localStorage.setItem('isJoined', res.data.isJoined);
      localStorage.setItem('communityAdmin', res.data.isAdmin);
      localStorage.setItem('communitySuperadmin', res.data.isSuperAdmin);
      localStorage.setItem('isSuperAdmin', res.data.isSuperAdmin);
      this.commonvalues.communitydata(this.values);
      this.onAddcommunity.emit(this.values)
      this.callThis()
      //////// console.log("companyHome emitting values to onAddCommunity");


    }, err => {
      if (!silent) {
        this.util.stopLoader();
      }
    });


  }

  callThis(){
    this.isJoined = localStorage.getItem('isJoined')
    this.isAdmin = localStorage.getItem('communityAdmin');
    this.isSuperAdmin = localStorage.getItem('communitySuperadmin');
    this.sendDataFunction({
      isJoined : this.isJoined,
      isSuperAdmin : this.isSuperAdmin,
      isAdmin : this.isAdmin,
      joinStatus : this.joinStatus
    })
  }


  businessupdatedata() {
    this.viewasmembers = false
    this.communitydata.userId = localStorage.getItem('userId')
    this.communitydata.communityId = this.communityId
    this.util.startLoader()
    this.API.updatePut("community/update", this.communitydata).subscribe(res => {
      this.util.stopLoader()
      this.values.userId = this.userId

      this.businesslogs = { src: AppSettings.photoUrl + res.logo }
      this.bannerimg = { src: AppSettings.photoUrl + res.banner }
        if(res){
          // Same stale-cache problem as the profile screen: the feed replays the
          // cached community details, so drop this community's entry before telling
          // listeners to re-read.
          this.gigsumoService.invalidateCommunityDetails(this.communityId)
          this.companydetailsapicall()
          var obj: any = {}
          obj.boolean = true
          this.commonvalues.setCommuityBoolean(obj)
        }
      },err => {
        this.util.stopLoader();
      });

  }


  fileChangeEvent(event, popupName): void {
    // this.formData.append('file',this.fileToUpload, this.fileUploadName);
    // this.formData.delete('file');
    this.imageChangedEvent = event;
    ////// console.log(event)
    if (event.target.files && event.target.files[0]) {
      this.fileUploadName = event.target.files[0].name;
      this.myFileInput.nativeElement.value//assigning the file through viewchild
    }

    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (!acceptedImageTypes.includes( event.target.files[0].type)) {
      Swal.fire('', 'Please upload the correct file type   (Only .jpg, .png, .jpeg)', 'info');
      this.myFileInput.nativeElement.value = "";

       this.modalRef.hide();
    }else{
    this.PopupServicevlaues(popupName);
    }
   }


  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    const byteString = window.atob(event.base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, ''));
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });

    this.fileToUpload = new File([blob], this.fileUploadName, { type: 'image/jpeg' });


  }


  imageLoaded() {

    const formData: FormData = new FormData();
    formData.append('file', this.fileToUpload, this.fileUploadName);

    // this.formData.append('file', this.fileToUpload, this.fileUploadName);

    this.util.startLoader()
    this.API.create('upload/image', formData).subscribe(res => {
      this.util.stopLoader()
      this.photoId = res.fileId;
      this.modalclose();

      formData.delete('file');
      if (res.fileId) {
        this.communitydata.banner = res.fileId
        this.businessupdatedata()
      }

    },err => {
      this.util.stopLoader();
      if(err.status==500){
      this.util.stopLoader();
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'Something went wrong while uploading image. Please, try again later.',
        showDenyButton: false,
        confirmButtonText: `ok`,
      })
    }
  });

    this.bannerflag = false;



  }

  members() {
    this.values.menu = 'memberspage'
    this.commonvalues.communitydata(this.values);

  }

  modalclose() {
    // for (let i = 1; i <= this.modalService.getModalsCount(); i++) {
    //   this.modalService.hide(i);
    // }
    this.modalRef.hide()
    this.myFileInput.nativeElement.value = ''
  }
  closePhoto() {
    this.modalRef.hide()
    // this.fileUploadName = ''
    this.myFileInput.nativeElement.value = '';
  }

  PopupServicevlaues(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {
      animated: true,
      backdrop: 'static'
    });
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  adminview(obj,checked) {
    
    obj?.posts?.ngOnInit()

    obj.adminflag = checked;
    obj.viewasmembers = false;
    obj.viewasAdmin = true;
    if(obj.adminData){
      obj.adminData.isAdmin = false;
    }
    // obj.CisAdmin = false;
    // obj.CisSuperAdmin = true;
    const isSuperAdmin = obj.CisSuperAdmin === true;
    obj.adminData.isSuperAdmin = isSuperAdmin;
    obj.values.viewadmin = true;
    obj.values.membersflage = true;
    obj.values.adminviewnavigation = true
    obj.values.members = obj.communitydata.members.length
    localStorage.setItem('adminviewflag', 'true')
    if (obj.values.menu == undefined) {
      obj.values.menu = 'communityhome'
    }

    obj.onAddcommunity.emit(obj.values);
    localStorage.setItem('viewAsadmin','true');
    localStorage.setItem('communitySuperadmin', String(isSuperAdmin));
    localStorage.setItem('isSuperAdmin', String(isSuperAdmin));
    obj.commonvalues.communitydata({
      ...obj.values ,
      viewasmembers : obj.viewasmembers,
      viewasAdmin : obj.viewasAdmin,
    });
    obj.onAddcommunity.emit(obj.values)
    console.log("admin object data" , obj);


  }

  viewasmember(obj , checked) {
    obj.viewasmembers = true;
    obj.viewasAdmin = false;
    obj.values.viewadmin = false; 
    obj.values.adminviewnavigation = false; 
    obj.values.membersflage = false;
    obj.adminData.isAdmin = true;
    // obj.CisAdmin = false;
    // obj.CisSuperAdmin = false;
    obj.values.admin = checked;
    obj.values.menu = "communityhome";
    obj.adminflag = false;
    obj.onAddcommunity.emit(obj.values)
    obj.commonvalues.communitydata({
      ...obj.values ,
      viewasmembers : obj.viewasmembers,
      viewasAdmin : obj.viewasAdmin,
    });
    console.log("member object data" , obj);
    localStorage.setItem('viewAsadmin','false'); 
    localStorage.setItem('communitySuperadmin','false'); 
    localStorage.setItem('isSuperAdmin','false'); 
  }


  mgsBtn() {
    const datas: any = {};
    datas.refererId = this.communityId
    //datas.communityid = this.communityId
    datas.type = "COMMUNITY";
    this.router.navigate(['message'], { queryParams: datas })
    /*this.API.query("message?type=COMMUNITY&refererId=" + datas.communityid).subscribe(res => {
      ////// console.log('Message data :' ,res)
      this.router.navigate(['message'], { queryParams: datas })
    });*/
  }


}
